var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdoptLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 182,
    viewBox: "0 0 160 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.948 150.54L133.647 129.238C130.339 125.93 125.841 124.078 121.166 124.078H115.256L106.436 128.488H88.7946C83.9434 128.488 79.9741 132.458 79.9741 137.309V146.129",
    stroke: "#F7F7F5",
    strokeWidth: 8.82051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.487 177.004L119.667 168.183H66.7436L27.0513 128.491L33.9754 126.771C40.7231 125.095 47.9118 126.639 53.3364 131.005L71.1538 146.132H106.436",
    stroke: "#F7F7F5",
    strokeWidth: 8.82051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 31.4609L26.3015 52.7625C29.6092 56.0702 34.1077 57.9225 38.7826 57.9225H44.6923L53.5128 53.5122H71.1538C76.0051 53.5122 79.9744 49.543 79.9744 44.6917V35.8712",
    stroke: "#F7F7F5",
    strokeWidth: 8.82051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4614 5L40.2819 13.8205H93.205L132.897 53.5128L125.973 55.2328C119.225 56.9087 112.037 55.3651 106.612 50.9989L88.7948 35.8718H53.5127",
    stroke: "#F7F7F5",
    strokeWidth: 8.82051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9742 74.3338C82.5763 69.3502 88.0891 66.0866 94.2194 66.8805C101.276 67.7625 106.436 74.1133 106.436 81.2138C106.436 88.8877 103.393 96.2528 97.9681 101.677L79.9742 119.671L61.9804 101.677C56.5558 96.2528 53.5127 88.8877 53.5127 81.2138C53.5127 73.7164 59.246 67.1892 66.7435 66.7923C72.4768 66.4836 77.5486 69.6148 79.9742 74.3779V74.3338Z",
    stroke: "#F7F7F5",
    strokeWidth: 8.82051,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdoptLight);
export default __webpack_public_path__ + "static/media/adopt_light.89a1423137b5c6d44f6d490d3c8dd5f2.svg";
export { ForwardRef as ReactComponent };